import { useState, useEffect, useRef } from "react";

export const ReadMore = ({ text }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const lineHeight = parseInt(window.getComputedStyle(textRef.current).lineHeight, 10);
      const maxHeight = lineHeight * 3; // Height of 3 lines
      setIsTruncated(textRef.current.scrollHeight > maxHeight);
    }
  }, [text]);

  return (
    <div>
      <p
        ref={textRef}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: isExpanded ? "unset" : 3,
          overflow: "hidden",
        }}
        dangerouslySetInnerHTML={{ __html: text }}
        className="ql-editor p-0  h-auto"
      ></p>

      {isTruncated && !isExpanded && (
        <button
          onClick={() => setIsExpanded(true)}
          style={{ cursor: "pointer", border: "none", background: "none", padding: 0, borderBottom: "1px solid #000" }}
        >
          Read More
        </button>
      )}
    </div>
  );
};
